<p-toast [life]="5000"></p-toast>

<app-topbar></app-topbar>
<div class="flex justify-content-center mt-3">
    <router-outlet />
</div>